import React from 'react';
import Parcel from 'single-spa-react/parcel';
import { mountRootParcel } from 'single-spa';
import { useNavigate } from 'react-router-dom';

const systemImport = (name: string): Promise<any> =>
    (window as any).System.import(name);

const AppointmentsParcel: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Parcel
            config={() => systemImport('@Smalljoys/PatientAppointments')}
            mountParcel={mountRootParcel}
            onPatientSelect={(patientId: string, meta?: { appointmentId?: string; practiceId?: string; practiceType?: string }) =>
                navigate(`/screening-v2/patient/${patientId}/session`, {
                    state: {
                        appointmentId: meta?.appointmentId,
                        practiceId: meta?.practiceId,
                        practiceType: meta?.practiceType ?? 'family_practice',
                        loginSource: 'provider-web',
                    },
                })
            }
            onLogout={() => navigate('/adminLoginV2')}
        />
    );
};

export default AppointmentsParcel;
